
<div class="p-4">
    @if(form()) {
        <cosmos-dynamic-form-v2 
            [form]="form"
            [model]="measurementModel"
            (formValue)="save($event)"
            [closeButton]="false">
        </cosmos-dynamic-form-v2>
        
        <div class="flex justify-end gap-2 mt-4">
            <button pButton severity="secondary" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
        </div>
    }
</div>
